import React from 'react';

const ListsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="35"
    viewBox="0 0 31 35"
  >
    <g fill="none">
      <path d="M0.2 34.7L0.2 5.2 21.1 5.2 15.1 13.2 13.2 23.9 14.1 24.4 24.1 18 27.4 12.3 27.4 34.7 0.2 34.7ZM2.7 17.4L2.8 19.8 11.8 19.9 12.1 17.4 2.7 17.4ZM2.8 14.9L12.3 14.9 12.9 12.6 2.8 12.5 2.8 14.9ZM2.8 10.1L13.8 10.1 15.9 7.7 2.8 7.8 2.8 10.1ZM15.9 20.8L17.1 13.8 26.9 0.9 30.5 3 21.9 16.6 15.9 20.8Z" />
    </g>
  </svg>
);

export default ListsIcon;
